export default __webpack_public_path__ + "static/media/b4.33eb3113.jpg";